<ion-header>

  <ion-toolbar color="marine">
    <ion-buttons slot="start">
      <ion-back-button text="" defaultHref="explore"></ion-back-button>
    </ion-buttons>
    <ion-title>Refer a friend</ion-title>
  </ion-toolbar>

</ion-header>


<ion-content>

  <div id="referral-code-wrapper">
    <h2 id="referral-code">
      <span *ngIf="!referralCode">
        <ion-spinner></ion-spinner>
      </span>
      <span *ngIf="referralCode">{{referralCode}}</span>
    </h2>
  </div>

  <hr>

  <p id="referral-description">
    Share your code to <span class="SC-red">give friends {{sharingService.referralDiscountPercentage}} off</span>
    their first Shortcut experience.

    <br><br>

    <span class="SC-red">You get {{sharingService.referralBonus}} credit</span> when they try Shortcut.
  </p>

  <ion-button class="SC-long-button SC-bottom-fixed-button" color="marine" (click)="share()" block>
    Share your code
  </ion-button>

</ion-content>